export default function ( val ) {
    return val.toString().trim().replace( /-$/, '' );
}

/**
 * Normalize sku value to match how a sku would be retrieved from Oracle
 * @param {String} val - the SKU value
 * @return {String} sku = normalized sku value
 * @example
 * 123 -> 123-
 */
export function normalizeSku( val ) {
    const sku = val.toString().trim();
    return /-/.test( sku ) ? sku : sku + '-';
}
